type ProcessingFeeItem = {
	description: string;
	total: number;
};

// The backend emits "Convenience Fee" and "Payment Processor Fee" as separate invoice items;
// merge so parkers see one combined line (persisted invoices and operator reporting stay itemized).
// Render-time only: call it where parker-facing invoice items are displayed.
export const mergeProcessingFees = <T extends ProcessingFeeItem>(items: T[]): T[] => {
	const convenience = items.find((item) => item.description === "Convenience Fee");
	const processor = items.find((item) => item.description === "Payment Processor Fee");
	if (!convenience || !processor) {
		return items;
	}
	return items
		.filter((item) => item.description !== "Convenience Fee")
		.map((item) =>
			item.description === "Payment Processor Fee" ? { ...item, total: item.total + convenience.total } : item,
		);
};
